<div class="nieuwsbrief" fxLayout="row" fxLayoutAlign="center center">
  <div class="newsletter-content" *ngIf="!subscribed" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="1.5rem">
    <div class="inschrijven">Schrijf je in voor onze nieuwsbrief</div>

    <div class="form-row" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="1rem">
      <input type="text" placeholder="emailadres" #emailAddressInput [disabled]="subscriptionDisabled" />
      <button (click)="handleSubscribe(emailAddressInput.value)" [disabled]="subscriptionDisabled">verzenden</button>
    </div>

    <div class="disclaimer">
      Door op verzenden te klikken ga je akkoord met onze <a routerLink="/privacy-statement">algemene voorwaarden</a>
    </div>
  </div>

  <div class="success" *ngIf="subscribed">Bedankt voor je inschrijving op onze nieuwsbrief!</div>
</div>

<div class="error" *ngIf="submitError">
  Er ging iets mis. Gelieve na te kijken of er een geldig e-mailadres werd ingevoerd en probeer het opnieuw.
</div>
